import React, { useState, useContext } from 'react';
import { get, isEmpty, range, sum } from 'lodash';
import { withStyles } from '@material-ui/core';
import Filter from './Filter'
import InvalidStatusDialog from './InvalidStatusDialog'
import Grid from '@material-ui/core/Grid';
import {Table, TableHead, TableRow, TableCell, TableBody} from '@material-ui/core';
import {Loader, TablePagination} from '../../../components';
import Button from '@material-ui/core/Button';
import {apvgkService} from "../../../services/apvgkService";
import PhotoModal from "./PhotoModal";
import moment from 'moment';
import StatFilter from "./StatFilter";
import ProgressBar from "../../../components/ProgressBar";
import {ProcessingType} from "../../../constants/fileConstants";

const styles = () => ({
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
});


const TrackPageView = ({ per_page, grz, min_date, showFilter = true }) => {
  const [filter, setFilter] = useState({
      min_date: moment(new Date(min_date  || (new Date().getTime() - 3600*1000))).format('YYYY-MM-DD HH:mm'),
      max_date: null,
      apvgk_id: null,
      TrackStateNumber: grz || null,
      without_number: null,
      rows1: null,
      more12: null,
      invalid: null,
      with_acts: null,
      gos: null,
      violation : null,
      page: 1,
      per_page: per_page || 10,
  });
  const [items, setItems] = useState({
      data: [],
      per_page:filter.per_page,
      current_page: 1,
  });
  const [load, setLoad] = useState(false)
  const fetchPage = async (filt) =>  {
      setItems({...items, ...{data: []}});
      setFilter({ ...filt});
      setLoad(true)
      try {
          const response = await apvgkService.getTrackDataPage(filt,);
          setItems(response);
      } catch (e) {
          setItems({...items, ...{data: []}});
          console.log(e);
      } finally {
        setLoad(false)
      }
  }
  const onExport = async () =>  apvgkService.exportTrackData(filter);
  React.useEffect(() => {
      fetchPage(filter)
  }, [])
  return (
      <>
        <Grid
            container
            role="main"
            className="container text-left"
            direction="column"
            spacing={16}
            wrap="nowrap"
        >
            <Grid item>
                <Grid container direction="column" spacing={16}>
                    <Grid container direction="row" spacing={16}>
                        <Grid item xs={12}>
                            <h2 className="h2-title">Данные о проездах</h2>
                        </Grid>
                      {showFilter && <Filter currentFilters={filter} onFiltersChange={fetchPage}/>}
                      {showFilter && <StatFilter/>}
                      {showFilter && <ProgressBar type={ProcessingType.GRUZ_TRACK_DATA} onExport={onExport} />}
                    </Grid>
                    <br/>
                </Grid>
            </Grid>
        </Grid>
        <main role="main" className="container text-center">
            {(!items.data || load) ? <Loader/> : <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Время</TableCell>
                            <TableCell>АПВГК</TableCell>
                            <TableCell>ГРЗ</TableCell>
                            <TableCell>Полоса</TableCell>
                            <TableCell>Длина</TableCell>
                            <TableCell>Ширина</TableCell>
                            <TableCell>Высота</TableCell>
                            <TableCell>Скорость</TableCell>
                            <TableCell>Общая масса</TableCell>
                            <TableCell>Параметры осей</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items.data.map((viewData, index) => {
                            return (
                                <TableRow
                                    key={`track-item-${viewData.id}`}
                                    style={{backgroundColor: viewData.Violation ? '#ff8a81' : 'white'}}
                                >
                                    <TableCell><Grid container alignItems="center"><PhotoModal id={viewData.id} label={viewData.id}/><InvalidStatusDialog trackData={viewData}/></Grid></TableCell>
                                    <TableCell>{(viewData.ExcessFactDate||'').replace(new Date().toLocaleDateString().split('\.').reverse().join('-'), '')}</TableCell>
                                    <TableCell>{(viewData.Properties.file || '').split('/').length > 3 ? (viewData.Properties.file || '').split('/')[2] : ''}</TableCell>
                                    <TableCell>{viewData.TrackStateNumber+(viewData.TrackCountryCode||"").replace('RUS', '')}</TableCell>
                                    <TableCell>{viewData.PlatformId}</TableCell>
                                    <TableCell>{viewData.Properties.TrackLength}</TableCell>
                                    <TableCell>{viewData.Properties.TrackWidth}</TableCell>
                                    <TableCell>{viewData.Properties.TrackHeight}</TableCell>
                                    <TableCell>{viewData.Properties.Speed}</TableCell>
                                    <TableCell>{viewData.Properties.TrackGrossWeight}</TableCell>
                                    <TableCell>{(() =>{
                                        let result = "";
                                        (new Array(12)).fill(null).map((v, i) => i + 1).forEach((v) => {
                                            let w = viewData.Properties["TrackThrust" + v];
                                            if (w && result) result += " X ";
                                            if (w) result += `${w}`;
                                        })
                                        return result;
                                    })()}</TableCell>
                                </TableRow>
                            );
                        }) || <TableRow>
                            <TableCell align="center" colSpan="11">
                                <span>Проезды не найдены</span>
                            </TableCell>
                        </TableRow>}
                    </TableBody>
            </Table>}
        </main>
          <TablePagination
              meta={items}
              onChangePage={page => {fetchPage({ ...filter, page,});}}
              onChangeRowsPerPage={per_page => { fetchPage({ ...filter, page: 1, per_page, })}}
          />
      </>
  );
};

export default withStyles(styles)(TrackPageView);
